import React from "react";

const features = [
  {
    title: "Interactive Simulations",
    description:
      "Dive into the world of blockchain with our interactive simulations that demonstrate how transactions occur between miners, senders, and receivers.",
  },
  {
    title: "Practice Transactions",
    description:
      "Engage in dummy transactions to grasp the complete workflow of blockchain technology, from creating addresses to verifying transactions.",
  },
  {
    title: "Real-time Feedback",
    description:
      "Receive instant feedback on your transactions to understand the impact of various factors on the blockchain network.",
  },
  {
    title: "Educational Resources",
    description:
      "Access a wealth of educational resources, including articles, videos, and tutorials, to deepen your understanding of blockchain concepts.",
  },
  {
    title: "Customizable Scenarios",
    description:
      "Customize scenarios to simulate different blockchain environments and explore various use cases.",
  },
  {
    title: "Community Support",
    description:
      "Join our vibrant community of tutors and learners to exchange ideas, ask questions, and collaborate on blockchain-related projects.",
  },
];

const Feature = () => {
  return (
    <div id="features" className="relative py-24">
      {/* Background Accent */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black via-transparent to-transparent opacity-80 pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h4 className="text-secondary font-bold tracking-wider uppercase text-sm">
            Key Features
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Ecosystem{" "}
            <span className="text-text-muted text-2xl ml-2 font-normal">(Coming Soon)</span>
          </h2>
          <p className="text-text-muted max-w-2xl mx-auto text-lg">
            Explore ASTRAHACK's innovative features for understanding blockchain transactions with
            interactive simulations, practice transactions, and educational resources.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="glass-card p-8 rounded-2xl hover:-translate-y-2 transition-transform duration-300 border border-white/5 group bg-white/5 hover:bg-white/10"
            >
              <div className="mb-6 relative">
                <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-primary transition-colors">
                {feature.title}
              </h3>
              <p className="text-text-muted leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Feature;
